<div class="gradient {{ gradient }}" [style.max-height]="maxHeight ? maxHeight + 'px' : undefined"></div>
